import * as React from "react";
import moment from "moment";
import { useState, useEffect } from "react";
import { VotacionElementCompleto } from "../../components/cards";
import { getCongresistasPublic, getLogDelegatesSeatNumberActiveConferencePublic, getGruposBancadaPublic, getVotosVotacionActivaPublic, getSeatCoordinateDiagramaPublic, getOpcionesSV4Public } from "../../services/juntanominadora";
import '../../styles/diagrama.css';
import '../../styles/animations.css';
import { getUltimaVotacionPublic, putOpciones } from "../../services/api";

const Diagrama: React.FC<{ onlyAsistencia?: boolean }> = ({ onlyAsistencia }) => {
    const [congresistas, setCongresistas] = useState<any[]>([]);
    const [gruposBancada, setGruposBancada] = useState<any[]>([]);
    const [logDelegatesSeatNumber, setLogDelegatesSeatNumber] = useState<any[]>([]);
    const [SVDelegatesVotaron, setSVDelegatesVotaron] = useState<any[]>([]);
    const [coordenadas, setCoordenadas] = useState<any[]>([]);
    const [congresistasConectados, setcongresistasConectados] = useState<number>(0);
    const [ultimaVotacion, setUltimaVotacion] = useState<any[]>([]);
    const [votosSI, setvotosSI] = useState<Number>(0);
    const [votosNO, setvotosNO] = useState<Number>(0);
    const [votosABS, setvotosABS] = useState<Number>(0);
    const [votosNV, setvotosNV] = useState<Number>(0);
    const [agendaTitleVotacionShure, setagendaTitleVotacionShure] = useState<string>("");
    const [diagramaShowUltimaVotaicon, setdiagramaShowUltimaVotaicon] = useState<boolean>(false);
    const [ultimasVotaciones, setultimasVotaciones] = useState<any[]>([]);
    const [idVotacionSeleccionada, setidVotacionSeleccionada] = useState<number>(0);
    const [dateState, setDateState] = useState(moment());

    const toggleShowUltimaVotacion = async () => {
        if (!onlyAsistencia) {
            setagendaTitleVotacionShure("");
            await putOpciones("diagrama-show-ultimavotacion", diagramaShowUltimaVotaicon ? "0" : "1");
        }
    };

    const onScroolSelect = () => {
        console.dir("scrool");
        const sel: any = this;
        const lasto = sel!.find('option:last');
        const s = sel.position().top + sel.height();
        const o = lasto.height() + lasto.position().top - 4;

        setTimeout(function () {
            if (o < s) {
                console.log('We need AJAX!');
            }
        }, 2200);
    };

    const onSelectVotacionChange = (event: any) => {
        setagendaTitleVotacionShure("");
        const value = event.target.value;
        setidVotacionSeleccionada(value);
    };

    useEffect(() => {
        if (congresistas.length === 0) {
            getCongresistasPublic().then((v) => {
                if (v.data.successed) {
                    setCongresistas(v.data.content);
                }
            });
        }

        if (gruposBancada.length === 0) {
            getGruposBancadaPublic().then((v) => {
                if (v.data.successed) {
                    setGruposBancada(v.data.content);
                }
            });
        }

        if (coordenadas.length === 0) {
            getSeatCoordinateDiagramaPublic().then((v) => {
                if (v.data.successed) {
                    setCoordenadas(v.data.content);
                }
            });
        }

        const inv = setInterval(async () => {
            if (!diagramaShowUltimaVotaicon) {
                setDateState(moment());
            }

            if (!onlyAsistencia) {
                await getOpcionesSV4Public().then((v) => {
                    if (v.data.successed) {
                        const opciones = v.data.content;
                        const opcion = opciones.find((o: any) => o.name === "diagrama-show-ultimavotacion");
                        setdiagramaShowUltimaVotaicon(opcion ? opcion.value === "1" : false);
                    }
                });
            }

            if (diagramaShowUltimaVotaicon) {
                await getUltimaVotacionPublic(idVotacionSeleccionada).then((v) => {
                    const content = v?.data?.content || [];

                    if (v?.data?.successed) {
                        let agendaTitle = "";

                        const ultimaVotacion = content[0] || [];
                        const agenda = content[1] || [];
                        const ultimasVotaciones = content[2] || [];
                        const datosVotacion = content[3] || [];

                        setUltimaVotacion(ultimaVotacion);

                        if (agenda.length) {
                            agendaTitle = agenda[0].name || "";
                        }

                        if (agendaTitleVotacionShure !== agendaTitle) {
                            let votosSI = 0;
                            let votosNO = 0;
                            let votosABS = 0;
                            let votosNV = 0;

                            ultimaVotacion.forEach((vr: any) => {
                                if (vr.Vote1 === 1) votosSI++;
                                else if (vr.Vote3 === 1) votosNO++;
                                else if (vr.Vote2 === 1) votosABS++;
                                else votosNV++;
                            });

                            setvotosSI(votosSI);
                            setvotosNO(votosNO);
                            setvotosABS(votosABS);
                            setvotosNV(votosNV);

                            if (datosVotacion.length && datosVotacion[0]?.StopDate) {
                                setDateState(moment(datosVotacion[0].StopDate.replace('Z', '')));
                            }
                        }

                        setagendaTitleVotacionShure(agendaTitle);

                        if (ultimasVotaciones.length) {
                            setultimasVotaciones(ultimasVotaciones);
                        }
                    }
                });
            }

            await getLogDelegatesSeatNumberActiveConferencePublic().then((v) => {
                if (v.data.successed) {
                    setLogDelegatesSeatNumber(v.data.content);
                    setcongresistasConectados(v.data.content.length);
                }
            });

            /*
            await getVotosVotacionActivaPublic().then((v) => {
                if (v.data.successed) {
                    const votes = v.data.content;
                    const SVDelegatesVotaron = Array.from(new Set(votes.map((item: any) => item.user_id)));
                    setSVDelegatesVotaron(SVDelegatesVotaron);
                }
            });
            */

        }, 2000);

        return () => {
            clearInterval(inv);
        };
    }, [congresistas, gruposBancada, coordenadas, diagramaShowUltimaVotaicon, onlyAsistencia, idVotacionSeleccionada, agendaTitleVotacionShure]);

    return (
        <div className={"container-fluid diagramaBackground"}>
            <img className="bgcurules" alt="Background" src="images/diagrama.png" />

            <div className="logoContainer" onClick={toggleShowUltimaVotacion}>
                <img draggable={false} alt="Congreso Nacional de Honduras" src={`images/logo.png?v1.0.0`} width="100%" />
            </div>

            <div className="cardsContainer">
                {coordenadas.map((coor: any) => {
                    let logDelegate: any[];
                    let congresista: any[];
                    let seat_id = 0;
                    let ld = 0;

                    if (diagramaShowUltimaVotaicon) {
                        logDelegate = ultimaVotacion.filter((vr: any) => {
                            return vr.SeatNumber === coor.SeatNumber;
                        });

                        congresista = logDelegate.length
                            ? congresistas.filter((c: any) => {
                                return c.delegate_id === logDelegate[0].LogDelegate_id;
                            })
                            : [];

                        ld = logDelegate.length ? logDelegate[0].LogDelegate_id : 0;
                    } else {
                        logDelegate = logDelegatesSeatNumber.filter((ld: any) => {
                            return ld.SeatNumber === coor.SeatNumber;
                        });

                        seat_id = logDelegate.length ? logDelegate[0].Seat_id : 0;

                        congresista = logDelegate.length
                            ? congresistas.filter((c: any) => {
                                return c.delegate_id === logDelegate[0].delegate_id;
                            })
                            : [];

                        ld = logDelegate.length ? logDelegate[0].delegate_id : 0;
                    }

                    const voto = congresista.length
                        ? ultimaVotacion.filter((vr: any) => {
                            return vr.LogDelegate_id === congresista[0].delegate_id;
                        })
                        : [];

                    const longerName = congresista.length
                        ? Math.max(
                            congresista[0].FirstName.split(" ")[0].length,
                            congresista[0].LastName.split(" ")[0].length
                        )
                        : 0;

                    let caracteresExtras = longerName - 8;

                    if (longerName === 8) {
                        caracteresExtras = 1;
                    }

                    const fonSizePercent = caracteresExtras > 0
                        ? 0.00755 - (caracteresExtras * 0.00052)
                        : 0.00755;

                    const nombreCompleto = congresista.length
                        ? `${congresista[0].FirstName} ${congresista[0].LastName}`.trim()
                        : "";

                    const nombreCompletoUpper = nombreCompleto.toUpperCase();

                    const imagenCongresista = nombreCompleto
                        ? `images/congresistas2630/${nombreCompleto}.JPG`
                        : "";

                    let congresistaName = congresista.length
                        ? `${congresista[0].FirstName.split(" ")[0]} ${congresista[0].LastName.split(" ")[0]}`.toUpperCase()
                        : "";

                    const bancada = congresista.length
                        ? gruposBancada.filter((b: any) => {
                            return b.group_name === congresista[0].bancada.toUpperCase().trim();
                        })
                        : [];

                    const groupColor1 = bancada.length ? bancada[0].group_color1 : '#9a9a9a';
                    const groupColor2 = bancada.length ? bancada[0].group_color2 : '#9a9a9a';

                    if (nombreCompletoUpper === 'JOSUE FABRICIO CARBAJAL SANDOVAL')
                        congresistaName = 'FABRICIO SANDOVAL';

                    if (nombreCompletoUpper === 'JARI DIXON HERRERA HERNANDEZ')
                        congresistaName = 'JARI DIXON';

                    if (nombreCompletoUpper === 'LUZ ANGELICA SMITH MEJIA')
                        congresistaName = 'ANGELICA SMITH';

                    if (nombreCompletoUpper === 'MARIA ISABEL VALDEZ BRIONES')
                        congresistaName = 'ISABEL VALDEZ';

                    return (
                        <React.Fragment key={coor.SeatNumber}>
                            <VotacionElementCompleto
                                //borrar después
                                //updateCoord
                                expand
                                showUltimaVotacion={diagramaShowUltimaVotaicon}
                                nombreCompleto={nombreCompleto}
                                imagenCongresista={imagenCongresista}
                                voto={voto}
                                top={coor.YCoordinate}
                                left={coor.XCoordinate}
                                id={coor.SeatNumber}
                                congresistaName={congresistaName}
                                fonSizePercent={fonSizePercent}
                                groupColor1={groupColor1}
                                groupColor2={groupColor2}
                                seat_id={seat_id}
                                ld={ld}
                                seat_number={coor.SeatNumber}
                            />
                        </React.Fragment>
                    );
                })}
            </div>

            <div className="div-fecha">
                <span>{dateState.format("dddd").toUpperCase()} {dateState.format("DD")} {dateState.format("MMMM").toUpperCase()} {dateState.format("YYYY")}</span>
            </div>

            <div className="div-hora">
                <span>{dateState.format("hh:mm A")}</span>
            </div>

            <div className="div-votacion-title">
                {!diagramaShowUltimaVotaicon &&
                    <h2 className="main-title fs-2vw lh-5">SESIÓN ORDINARIA</h2>
                }

                {diagramaShowUltimaVotaicon &&
                    <React.Fragment>
                        <div className="title-votacion">
                            VOTACIÓN: {agendaTitleVotacionShure === "" ? <div className="dot-flashing"></div> : agendaTitleVotacionShure}
                        </div>

                        <select
    onChange={onSelectVotacionChange}
    style={{
        width: "260px",
        height: "28px",
        maxWidth: "260px",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        border: "1px solid #2f80ed",
        background: "#111827",
        color: "#fff",
        borderRadius: "6px",
        fontSize: "12px",
        padding: "0 8px"
    }}
>
    {ultimasVotaciones.map((votacion: any) => (
        <option
            key={votacion.Id}
            value={votacion.Id}
        >
            {votacion.name?.substring(0, 60)}
        </option>
    ))}
</select>
                    </React.Fragment>
                }
            </div>

            <div className="leyenda">
                {!diagramaShowUltimaVotaicon &&
                    <React.Fragment>
                        <h2 className="main-title">DIPUTADOS PRESENTES</h2>
                        <span className="congresistas-conectados-number">{congresistasConectados}</span>
                    </React.Fragment>
                }

                {diagramaShowUltimaVotaicon &&
                    <React.Fragment>
                        <table className="tableLeyenda">
                            <tbody>
                                <tr>
                                    <td></td>
                                    <td style={{ background: "none" }}>
                                        RESULTADOS
                                    </td>
                                </tr>
                                <tr>
                                    <td><div className="circleResults" style={{ background: "#00ff00" }} /></td>
                                    <td>SI</td>
                                    <td>{votosSI.toString()}</td>
                                </tr>
                                <tr>
                                    <td><div className="circleResults" style={{ background: "#f90000" }} /></td>
                                    <td>NO</td>
                                    <td>{votosNO.toString()}</td>
                                </tr>
                                <tr>
                                    <td><div className="circleResults" style={{ background: "#f9fd00" }} /></td>
                                    <td>ABSTENCIÓN</td>
                                    <td>{votosABS.toString()}</td>
                                </tr>
                                <tr>
                                    <td><div className="circleResults" style={{ background: "#000000" }} /></td>
                                    <td>NO VOTARON</td>
                                    <td>{votosNV.toString()}</td>
                                </tr>
                                <tr>
                                    <td><div className="circleResults" style={{ background: "#ffffff" }} /></td>
                                    <td>PRESENTES</td>
                                    <td>{ultimaVotacion.length}</td>
                                </tr>
                            </tbody>
                        </table>
                    </React.Fragment>
                }
            </div>

            <div className="custom-select" style={{ width: "0.96vw", height: "0.96vh", position: "absolute", top: "0.4vh", left: "0.2vw" }}>
            </div>
        </div>
    );
};

export default Diagrama;